export default __webpack_public_path__ + "static/media/features1.2c29989b.svg";